<template>  
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Feedback
      </p>
      <a class="close-modal" aria-label="close" @click="closeModal()">
        <i class="material-icons">close</i>
      </a>
    </header>
    <section class="modal-card-body">
      <p>
        Would you recommend the Trade Discovery Platform to your friends or colleagues? 
      </p>

      <div class="numbers-row">
        <div class="number-circle" v-for="(n, index) in 11" :key="n"
          @click="selectedNumber = index"
          :class="{ 'number-circle--selected': selectedNumber === index}"
        >
          {{ index }}
        </div>
      </div>

      <div class="numbers-label-row">
        <div>
          Not Likely
        </div>
        <div>
          Most Likely
        </div>
      </div>

      <textarea name="" id="" cols="30" rows="4" class="textarea" placeholder="Comments" v-model="comments"></textarea>


      <div class="button-row flexbox-row-end">
        <button class="button button-secondary button-outline" @click="closeModal()">
          Cancel
        </button>
        <button class="button button-primary" @click="submitFeedback()" :disabled="selectedNumber < 0 || loading">
          Submit Feedback <div class="labs-loader" v-if="loading"></div>
        </button>
      </div>
      
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import FRTBApi from '@/api/frtb.api';

@Component({
  components: {
  },
})
export default class Upgrade extends Vue {

  public selectedNumber: number = -1;
  public comments: string = '';
  public loading: boolean = false;

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public success() {
    this.$store.commit('setToastSuccess', 'Feedback successfully submitted!');
    this.closeModal();
  }

  public error() {
    this.$store.commit('setToastError', 'Error sending feedback. Please try again.');
  }

  public async submitFeedback() {
    this.loading = true;

    try {
      const consented = await FRTBApi.sendFeedback(this.selectedNumber, this.comments);
      this.success();
    } catch (e) {
      this.error();
    }

    this.loading = false;
  }
}

</script>

<style scoped lang="scss">
@import '@/scss/partials/_settings.colors.scss';
  .numbers-row {
    display: flex;
    .number-circle {
      width: 34px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      border: 1px solid $grey-220;
      border-radius: 25px;
      margin-right: 6px;
      font-weight: 600;
      font-size: 1rem;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        cursor: pointer;
        background-color: $grey-220;
      }

      &--selected {
        background-color: $refinitiv-blue;
        color: #fff;

        &:hover {
          cursor: pointer;
          background-color: $link-blue;
        }
      }
    }
  }

  .numbers-label-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: $grey-180;
    font-size: .85rem;
    margin-top: 7px;
    font-weight: 500;
  }

  .button-row {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .button-secondary {
      margin-right: 10px;
    }
    .button-primary {
      .labs-loader {
        margin-left: 5px;
        width: 24px;
        margin-right: 0;

        &::after {
            width: 24px;
            height: 24px;
            top: 6px;
        }
      }
    }
  }

  .textarea {
    margin-top: 30px;
  }
</style>